'use strict'

import {
  Polymer
} from '@polymer/polymer/lib/legacy/polymer-fn.js'
import {
  dom,
  flush
} from '@polymer/polymer/lib/legacy/polymer.dom.js'
import {
  html
} from '@polymer/polymer/lib/utils/html-tag.js'
import '@polymer/iron-collapse/iron-collapse'
Polymer({
  is: 'moskito-rating-bar',
  _template: html`
<style include="iron-flex iron-flex-alignment">
  :host {
    --moskito-rating-width: 420px;
    --moskito-rating-height: 12px;
    --moskito-rating-color: var(--primary-color);
  }
  rect#fg {
    fill: var(--moskito-rating-color);
  }
  rect#bg {
    fill: var(--paper-blue-grey-200);
  }
  svg {
    border-radius: 12px;
    box-shadow: 1px 1px 6px 1px rgba(30, 30, 30, 0.3) inset;
  }
</style>
<div class="horizontal layout">
<svg
  width$="{{width}}"
  height$="{{height}}"
  class="flex"
  >
  <g>
    <rect
       style="opacity:1;fill-opacity:0.2"
       id="bg"
       width$="{{percentWidth}}"
       height$="{{height}}"
       x="0"
       y="0" />
    <rect
       y="0"
       x="0"
       width$="{{progressWidth}}"
       height$="{{height}}"
       id="fg"
       style="opacity:1;fill-opacity:1" />
  </g>
</svg>
</div>
`,
  properties: {
    rating: { type: String, value: '0.4' },
    width: { type: String, value: '100' },
    height: { type: String, value: '10' },
    scale: { type: String, value: '1' },
    progressWidth: {
      type: String,
      computed: 'generateProgressWidth(width, rating, scale)'
    },
    percentWidth: {
      type: String,
      computed: 'generatePercentWidth(width)'
    }
  },
  generateProgressWidth: function (width, rating, scale) {
    let colors = ['#cfd8dc', '#b0bec5', '#90a4ae', '#78909c', '#607d8b', '#546e7a', '#455a64']
    let color = colors[Math.floor(rating / scale * (colors.length - 1))]
    this.updateStyles({
      '--moskito-rating-color': color
    })
    return (100 * rating / scale) + '%'
  },
  generatePercentWidth: function (width) {
    return 100 + '%'
  }
})
